module.exports = __webpack_public_path__ + "static/media/out-buy.908adc00.svg";